import noDataFound from '../../../Assets/nodatafound.svg';

const NoDataFound = () => {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '76vh',
            textAlign: 'center'
        }}>
            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/nodatafound.svg' alt="No Data To Show" style={{ height: "500px", width: "500px"  }} />
        </div>
        
    );
};

export default NoDataFound;